import React from 'react';
import { Button, ButtonProps, Spinner } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

interface SubmitButtonProps {
    onSubmit: () => void;
    disabled?: boolean;
    isSubmitting?: boolean;
    buttonProps?: ButtonProps;
    children?: React.ReactNode;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
    onSubmit,
    disabled,
    isSubmitting,
    buttonProps,
    children,
}) => {
    const { t } = useTranslation();

    return (
        <Button
            appearance="primary"
            onClick={onSubmit}
            disabled={disabled}
            icon={isSubmitting ? <Spinner size="tiny" /> : undefined}
            iconPosition="before"
            {...buttonProps}
        >
            {children ?? t('Submit')}
        </Button>
    );
};

export default SubmitButton;
